import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import SEO from "./components/SEO";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import GovernmentProjects from "./pages/GovernmentProjects";
import PrivateProjects from "./pages/PrivateProjects";
import Contact from "./pages/Contact";
import MediaCoverage from "./pages/MediaCoverage";

const AppContent = () => {
  const location = useLocation();
  
  return (
    <>
      <SEO pathname={location.pathname} />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/government-projects" element={<GovernmentProjects />} />
          <Route path="/private-projects" element={<PrivateProjects />} />
          <Route path="/media" element={<MediaCoverage />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
